import { FC, memo } from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import UI components
import { Button } from '@geneui/components';
// Import components
import ButtonWithDropDown from 'components/common/ButtonWithDropDown';
import ButtonWithLoader from 'components/common/ButtonWithLoader';
// Import constants
import { l } from 'constants/common';
// Import styles
import styles from './ResetSave.module.scss';

interface Props {
    disableReset?: boolean;
    disableSave?: boolean;
    isLoadingSave?: boolean;
    hasAdditionalSettings?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    buttonWithDropDownConfig?: Record<string, any>;
    setMode?: (mode: string) => void;
    resetButtonClickHandler?: () => void;
    saveButtonClickHandler?: () => void;
    testSendButtonClickHandler?: () => void;
}

const ResetSave: FC<Props> = (props) => {
    const {
        disableReset = false,
        disableSave = false,
        isLoadingSave = false,
        hasAdditionalSettings = false,
        buttonWithDropDownConfig = {},
        resetButtonClickHandler = noop,
        setMode = noop,
        testSendButtonClickHandler,
        saveButtonClickHandler = noop,
    } = props;
    const { t } = useTranslation();

    return (
        <>
            <Button
                flexibility="default"
                className={classNames('crm-page-headline_button-box_button', hasAdditionalSettings ? 'mr-20' : 'mr-10')}
                appearance="outline"
                onClick={resetButtonClickHandler}
                disabled={disableReset}
            >
                {t(l.Reset)}
            </Button>

            {hasAdditionalSettings ? (
                <ButtonWithDropDown
                    name={t(l.Save)}
                    handleSave={saveButtonClickHandler}
                    buttonWithDropDownConfig={buttonWithDropDownConfig}
                    setSaveButtonLabel={setMode}
                    disabled={disableSave}
                />
            ) : (
                <ButtonWithLoader
                    flexibility="default"
                    isLoading={isLoadingSave}
                    className="crm-page-headline_button-box_button"
                    color="confirm"
                    onClick={saveButtonClickHandler}
                    isDisabled={disableSave}
                >
                    {t(l.Save)}
                </ButtonWithLoader>
            )}

            {!!testSendButtonClickHandler && (
                <Button
                    flexibility="default"
                    className={classNames(
                        'crm-page-headline_button-box_button',
                        styles.buttonWithoutEllipsis,
                        hasAdditionalSettings ? 'ml-20' : 'ml-10',
                    )}
                    color="confirm"
                    appearance="outline"
                    onClick={testSendButtonClickHandler}
                >
                    {t(l.TestSend)}
                </Button>
            )}
        </>
    );
};

export default memo(ResetSave);
